import { http, API_HOST, API_ROOT } from '../../../util/http';

export const cartApi = {
  getCart() {
    return http.get(API_HOST+API_ROOT+'cart/', true);
  }
};